/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ImportCsvWorkPackages$Params {
  projectId: string;
      body: string
}

export function importCsvWorkPackages(http: HttpClient, rootUrl: string, params: ImportCsvWorkPackages$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, importCsvWorkPackages.PATH, 'post');
  if (params) {
    rb.query('projectId', params.projectId, {});
    rb.body(params.body, 'text/csv');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

importCsvWorkPackages.PATH = '/v0/workPackages/import-csv';
